export const Field = ({ label, testid, ...props }) => (
  <label className="block">
    <span className="text-sm font-medium">{label}</span>
    <input
      data-testid={testid}
      {...props}
      className="mt-1.5 w-full h-11 rounded-lg px-3 text-sm outline-none focus:ring-2 focus:ring-[var(--accent)]"
      style={{ background: "var(--muted-bg)", border: "1px solid var(--line)", color: "var(--ink)" }}
    />
  </label>
);
